import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Filter, SortAsc } from 'lucide-react';
import RoomCard from '../components/RoomCard';
import BookingWidget from '../components/BookingWidget';
import { usePageTitle } from '../hooks/usePageTitle';

// --- IMPOR DATABASE STATIS ---
import roomsDataRaw from '../data/rooms.json';
const roomsList = Array.isArray(roomsDataRaw) ? roomsDataRaw : (roomsDataRaw?.default || []);

export default function Rooms() {
  const { i18n: _i18n_pt } = useTranslation(); 
  usePageTitle(_i18n_pt.language === 'id' ? 'Pilihan Kamar' : 'Our Rooms');
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  
  const [rooms] = useState(roomsList);
  const [sortBy, setSortBy] = useState('price_asc');
  const [filterGuests, setFilterGuests] = useState(0);

  // Logika Filter & Sorting Statis
  const filtered = rooms
    .filter((r) => filterGuests === 0 || r.capacity >= filterGuests)
    .sort((a, b) => {
      if (sortBy === 'price_asc') return a.price_per_night - b.price_per_night;
      if (sortBy === 'price_desc') return b.price_per_night - a.price_per_night;
      if (sortBy === 'size') return b.size_sqm - a.size_sqm;
      return 0;
    });

  return (
    <div className="bg-cream min-h-screen">
      {/* Header */}
      <div className="bg-primary-950 pt-32 pb-16 px-6 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10" style={{ backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23d4881c' fill-opacity='0.8'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4z'/%3E%3C/g%3E%3C/svg%3E")` }} />
        <div className="relative max-w-6xl mx-auto text-center">
          <p className="text-accent-400 text-xs font-sans tracking-[0.3em] uppercase mb-3">— Ndalem Mataram —</p>
          <h1 className="font-display text-5xl text-white font-bold mb-4">{t('rooms.title')}</h1>
          <p className="text-white/60 font-body text-lg max-w-2xl mx-auto">{t('rooms.subtitle')}</p>
        </div>
      </div>

      {/* Booking widget */}
      <div className="max-w-6xl mx-auto px-6 mb-4">
        <BookingWidget variant="inline" />
      </div>

      <div className="max-w-6xl mx-auto px-6 pb-24">
        {/* Filters */}
        <div className="flex flex-wrap items-center justify-between gap-4 mb-8 p-4 bg-white rounded-xl border border-gray-100 shadow-sm">
          <div className="flex items-center gap-2 flex-wrap">
            <Filter size={16} className="text-primary-600" />
            <span className="text-sm font-sans font-semibold text-dark">Filter:</span>
            {[0, 1, 2, 3, 4].map((n) => (
              <button
                key={n}
                onClick={() => setFilterGuests(n)}
                className={`px-3 py-1.5 rounded-lg text-xs font-sans font-medium transition-colors ${filterGuests === n ? 'bg-primary-600 text-white' : 'bg-gray-100 text-gray-600 hover:bg-primary-50'}`}
              >
                {n === 0 ? (lang === 'id' ? 'Semua' : 'All') : `${n}+ ${t('common.guests')}`}
              </button>
            ))}
          </div>
          <div className="flex items-center gap-2">
            <SortAsc size={16} className="text-primary-600" />
            <select
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              className="text-sm font-sans text-dark border border-gray-200 rounded-lg px-3 py-1.5 focus:outline-none focus:border-primary-500"
            >
              <option value="price_asc">{lang === 'id' ? 'Harga Terendah' : 'Lowest Price'}</option>
              <option value="price_desc">{lang === 'id' ? 'Harga Tertinggi' : 'Highest Price'}</option>
              <option value="size">{lang === 'id' ? 'Kamar Terbesar' : 'Largest Room'}</option>
            </select>
          </div>
        </div>

        {/* Results */}
        {filtered.length === 0 ? (
          <div className="text-center py-20 text-gray-400 font-sans">
            {lang === 'id' ? 'Tidak ada kamar yang tersedia untuk filter ini.' : 'No rooms available for this filter.'}
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filtered.map((room) => (
              <RoomCard key={room.id} room={room} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}